import { TabContent, TabPane } from "reactstrap";
import { WizardNavProps } from "../../../../../../../types/Forms";
import FinishForm from "../../../common/FinishForm";
import BankInfoForm from "./BankInfoForm";
import InquiresForm from "./InquiresForm";
import PersonalInfoForm from "./PersonalInfoForm";

const CustomTabContent: React.FC<WizardNavProps> = ({ steps, activeCallBack, differentId }) => {
  return (
    <TabContent className="dark-field" activeTab={steps}>
      <TabPane tabId={1}>
        <PersonalInfoForm activeCallBack={activeCallBack} />
      </TabPane>
      <TabPane tabId={2}>
        <BankInfoForm activeCallBack={activeCallBack} />
      </TabPane>
      <TabPane tabId={3}>
        <InquiresForm activeCallBack={activeCallBack} differentId={differentId} />
      </TabPane>
      <TabPane tabId={4}>
        <FinishForm />
      </TabPane>
    </TabContent>
  );
};
export default CustomTabContent;
